import { render, staticRenderFns } from "./TicketAbonoSencillo.vue?vue&type=template&id=6565f942&scoped=true&"
import script from "./TicketAbonoSencillo.vue?vue&type=script&lang=js&"
export * from "./TicketAbonoSencillo.vue?vue&type=script&lang=js&"
import style0 from "./TicketAbonoSencillo.vue?vue&type=style&index=0&id=6565f942&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565f942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
